import * as actionTypes from 'app/infrastructure/ui/form/action-types';
import { errorSafe } from 'app/infrastructure/redux';
import { ActionDispatching } from 'app/types-shared';

export const actionCreators = {
  
  /**
   * Opens a application internal debugging panel to inspect properties of a rendered or failing UI component
   */
  inspect: (componentContext: any, error?: any): ActionDispatching<any, any> =>
    errorSafe(async (dispatch: any, getState: any) => {

      dispatch(new actionTypes.InspectComponent(componentContext, error));
    }),

  preview: (props: any): ActionDispatching<any, any> =>
    errorSafe(async (dispatch: any, getState: any) => {

      dispatch(new actionTypes.InspectPreviewEdit(props));
    })
};
